import { Select } from '../../atoms/select/Select';
import styles from './ProductActions.module.scss';
import React from 'react';
import { CarretArrowDownJAG } from '../../atoms/icons';
import { optionsActions, qtySelectorOptions } from './options';


export interface QtySelectorProps {
  customArgs: Record<string, any>;
  register: any;
  setValue: (name: string, value: any) => void;
  availableQuantity: number;
  variant: any | null;
  label?: React.ReactNode | string;
}

export const QtySelector = ({
  customArgs,
  register,
  setValue,
  availableQuantity,
  variant,
  label,
}: QtySelectorProps) => {
  return (
    <Select
      {...customArgs}
      /*@ts-ignore*/
      label={label}
      className={styles.customSelectStyle}
      /*@ts-ignore*/
      customIcon={optionsActions?.isJag && CarretArrowDownJAG}
      customClasses={{ selectDropdown: styles.selectDropdown }}
      name="qty"
      register={register}
      onChange={(e) => {
        setValue('qty', Number(e.target.value));
      }}
      selectAriaLabel="Quantity selector"
      {...qtySelectorOptions}
    >
      {Array.from(
        {
          length: (function () {
            if (!variant || availableQuantity <= 0) {
              return 1;
            } else {
              if (availableQuantity > 10) return 10;

              return availableQuantity;
            }
          })(),
        },
        (_, i) => i + 1,
      ).map((el, index) => {
        return <Select.Option key={el} index={index} label={el} value={el} htmlContent={<span>{el}</span>} />;
      })}
    </Select>
  );
};
